@if (form) {
  <mg-simple-form [formGroup]="form" [errorMessage]="errorMessage" label="Bericht" title="{{item?.title}}" (onSubmit)="onSubmit($event)" (onDelete)="onDelete()" [customActions]="customActions" [dtoClassName]="dtoTypeName">
    <mg-simple-form-section title="Algemeen">
      <mg-simple-form-row>
        <span>
          <mat-form-field>
            <mat-label>Datum Vanaf</mat-label>
            <input matInput [matDatepicker]="pickerDate" formControlName="date">
            <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerDate></mat-datepicker>
            <mat-error>{{form.mgErrors.date}}</mat-error>
          </mat-form-field>
        </span>
        <span>
          <mat-form-field>
            <mat-label>Verloopt op</mat-label>
            <input matInput [matDatepicker]="pickerExpiringDate" formControlName="expiringDate">
            <mat-datepicker-toggle matSuffix [for]="pickerExpiringDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerExpiringDate></mat-datepicker>
            <mat-error>{{form.mgErrors.expiringDate}}</mat-error>
          </mat-form-field>
        </span>
      </mg-simple-form-row>
      <mg-simple-form-row>
        <span mg-colspan-2>
          <mat-form-field pd-size-32>
            <mat-label>Titel</mat-label>
            <input type="text" matInput formControlName="title">
            <mat-error>{{form.mgErrors.title}}</mat-error>
          </mat-form-field>
        </span>
      </mg-simple-form-row>
      <br>
        <hr style="opacity: 0.2;">
        <br>
          <mg-simple-form-row>
            <span mg-colspan-3>
              <mat-form-field pd-size-max>
                <mat-label>Bericht</mat-label>
                <textarea cdkTextareaAutosize type="text" matInput formControlName="message" class="TextareaLineHeight"></textarea>
                <mat-error>{{form.mgErrors.message}}</mat-error>
              </mat-form-field>
            </span>
          </mg-simple-form-row>
        </mg-simple-form-section>
      </mg-simple-form>
    }